import { BAILocale } from '.';
import ko_KR from 'antd/es/locale/ko_KR';

const localeValue: BAILocale = {
  lang: 'ko',
  antdLocale: ko_KR,
};

export default localeValue;
